import { useQuery } from '@apollo/client/react';
import { createFileRoute } from '@tanstack/react-router';
import { useBreadcrumbLabel } from '../../components/BreadcrumbLabelsContext.js';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import {
  GET_PRICE_RULE,
  type GetPriceRuleQueryResult,
  type GetPriceRuleQueryVariables,
} from '../../modules/pricing-rules/operations.js';
import { PricingRuleDetailView } from '../../modules/pricing-rules/pricing-rule-detail.js';
import { pricingRuleScopeSummaryText } from '../../modules/pricing-rules/pricing-rule-scope-summary-text.js';

export const Route = createFileRoute('/pricing-rules/$priceRuleId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: PricingRuleDetailPage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component; HMR is handled by the router's own module system
function PricingRuleDetailPage() {
  const { priceRuleId } = Route.useParams();
  const { data, loading } = useQuery<GetPriceRuleQueryResult, GetPriceRuleQueryVariables>(
    GET_PRICE_RULE,
    { variables: { id: priceRuleId } },
  );
  // PriceRule has no owned name column, so its scope summary ("Pre-Roll · All customers") stands in as the breadcrumb/title label.
  useBreadcrumbLabel(
    priceRuleId,
    data?.priceRule ? pricingRuleScopeSummaryText(data.priceRule) : undefined,
  );

  return (
    <div>
      {loading ? (
        <div className="text-sm text-muted-foreground">Loading...</div>
      ) : (
        <PricingRuleDetailView priceRule={data?.priceRule} />
      )}
    </div>
  );
}
